import { Button, Modal } from "materia"
import { useTranslation } from "react-i18next"
import s from "./RetractConfirm.module.scss"

type RetractConfirmProps = {
  onConfirm: () => void
  onCancel: () => void
}

export function RetractConfirm({ onConfirm, onCancel }: RetractConfirmProps) {
  const { t } = useTranslation()

  return (
    <Modal
      ariaLabel={String(t("chat.DELETE_MESSAGE_TITLE"))}
      onClose={onCancel}
    >
      <div className={s.confirm}>
        <h2 className={s.confirm__title}>{t("chat.DELETE_MESSAGE_TITLE")}</h2>
        <p className={s.confirm__body}>{t("chat.DELETE_MESSAGE_BODY")}</p>

        <div className={s.confirm__actions}>
          <Button theme="delete" borderRadius="24" onClick={onConfirm}>
            {t("chat.DELETE_MESSAGE")}
          </Button>
          <Button theme="cancel" borderRadius="24" onClick={onCancel}>
            {t("actions.CANCEL")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
